import { createAction } from '@reduxjs/toolkit';

import { SourceType } from '@/types/document';
import { Language } from '@/types/i18n';

export const showFileViewer = createAction<{ src: string; type: SourceType }>(
  'ui/show-file-viewer',
);
export const setFileViewerScrolledToBottom = createAction<boolean>(
  'ui/set-file-viewer-scrolled-to-bottom',
);
export const hideFileViewer = createAction('ui/hide-file-viewer');

export const showUserInfo = createAction('ui/show-user-info');
export const hideUserInfo = createAction('ui/hide-user-info');

export const showReviewPersonalInfo = createAction(
  'ui/show-review-personal-info',
);
export const hideReviewPersonalInfo = createAction(
  'ui/hide-review-personal-info',
);

export const showUpdatePersonalInfo = createAction(
  'ui/show-update-personal-info',
);
export const hideUpdatePersonalInfo = createAction(
  'ui/hide-update-personal-info',
);

export const setUserSelectedLanguage = createAction<Language | undefined>(
  'ui/set-user-selected-language',
);

export const updateProcessStep = createAction<{
  current: number;
  uniqueName: string;
}>('ui/update-process-step');

export const initiateProcessStep = createAction<{
  total: number;
  current?: number;
  uniqueName: string;
}>('ui/initiate-process-step');

export const resetProcessStep = createAction<{
  uniqueName: string;
}>('ui/reset-process-step');
